import React, { useState, useRef, useEffect, useContext } from "react";
import { useTheme } from "@mui/material/styles";
import Button from "@mui/material/Button";
import ButtonGroup from "@mui/material/ButtonGroup";
import Typography from "@mui/material/Typography";
import MenuItem from "@mui/material/MenuItem";
import MenuList from "@mui/material/MenuList";
// import ListItemIcon from "@mui/material/ListItemIcon";
import Popover from "@mui/material/Popover";

import AddIcon from "@mui/icons-material/Add";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
// import AssignmentOutlinedIcon from "@mui/icons-material/AssignmentOutlined";

import SearchField from "../Components/SearchField";
import SchedulerContext from "./schedulerContext";
import useInteraction from "../UserSurveys/useInteractions";
import { useTranslation } from "react-i18next";
import useClasses from "../useClasses";

const styles = (theme) => ({
  buttonGroupContainer: {
    display: "flex",
  },
  buttonGroup: {
    marginRight: "auto",
    maxWidth: 200,
    background: theme.palette.background.paper,
    boxShadow: theme.shadows[3],
  },
  icon: {
    minWidth: theme.spacing(5),
    color: theme.palette.text.secondary,
  },
  iconBtn: {
    backgroundColor: theme.palette.background.paper,
    border: "1px solid rgba(0, 0, 0, 0.12)",
    marginTop: -theme.spacing(2),
    "&:hover": {
      backgroundColor: theme.palette.background.paper,
    },
  },
  list: {
    maxHeight: "230px",
    minWidth: "252px",
    overflow: "auto",
    transition: theme.transitions.create("max-height", {
      duration: theme.transitions.duration.shortest,
    }),
  },
});
const buttonId = "split-button";

// Blue split create button
function AddButton({ disabled }) {
  const classes = useClasses(styles);
  const theme = useTheme();
  const { t } = useTranslation();
  const { interaction, setInteraction } = useContext(SchedulerContext);
  const [open, setOpen] = useState(false);
  const anchorRef = useRef(null);
  const [userText, setUserText] = useState("");
  const [list, setList] = useState([]);

  // server state
  const { interactions } = useInteraction();

  // serach in list
  useEffect(() => {
    if (interactions) {
      const initList = interactions.slice(0).reverse();
      const newList = initList.filter(
        (item) =>
          item.name
            .toLowerCase()
            .indexOf(userText.toLowerCase().replace(/\s/g, "")) !== -1
      );
      setList(userText === "" ? initList : newList.slice(0, 2));
    }
  }, [userText, interactions]);

  const handleMenuItemClick = (itemId) => {
    const item = list.find((item) => item.id === itemId);
    if (item) setInteraction({ ...item, open: false });
    handleResetMenu();
  };

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }
    handleResetMenu();
  };

  const handleResetMenu = () => {
    setOpen(false);
    setUserText("");
  };

  return (
    <div className={classes.buttonGroupContainer}>
      <ButtonGroup
        variant="outlined"
        color="primary"
        ref={anchorRef}
        aria-label="split button"
        className={classes.buttonGroup}
        disabled={interactions?.length === 0 || disabled}
      >
        <Button
          startIcon={<AddIcon />}
          onClick={() => setInteraction((prev) => ({ ...prev, open: true }))}
        >
          <Typography noWrap variant="button">
            {interaction.name}
          </Typography>
        </Button>
        <Button
          color="primary"
          size="small"
          aria-controls={buttonId}
          aria-expanded={"true"}
          aria-label="select merge strategy"
          aria-haspopup="menu"
          onClick={handleToggle}
        >
          <ArrowDropDownIcon />
        </Button>
      </ButtonGroup>{" "}
      <Popover
        open={open}
        anchorEl={anchorRef.current}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
      >
        <div>
          <div
            style={{
              padding: theme.spacing(1, 1, 1, 1),
              borderBottom: "1px solid rgba(0,0,0,0.2)",
              display: "flex",
            }}
          >
            <SearchField
              setUserText={setUserText}
              placeholder={t("common.search")}
              variant="searchQuestionType"
              autoFocus={true}
            />
          </div>
          <MenuList id={buttonId} className={classes.list}>
            {list.length > 0 ? (
              list.map((item) => (
                <MenuItem
                  key={"MenuItem" + item.id}
                  onClick={() => handleMenuItemClick(item.id)}
                  selected={interaction.id === item.id}
                >
                  {/*  <ListItemIcon className={classes.icon}>
                  <AssignmentOutlinedIcon fontSize="small" />
                </ListItemIcon> */}
                  <Typography noWrap>{item.name}</Typography>
                </MenuItem>
              ))
            ) : (
              <MenuItem disabled>
                <Typography>{t("common.noResults")}</Typography>
              </MenuItem>
            )}
          </MenuList>
        </div>
      </Popover>
    </div>
  );
}

export default AddButton;
